import axios from 'axios';

// Get clean host port dynamically or fallback to localhost:8000
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const cleanPort = isLocal ? 'http://localhost:8000' : `${window.location.protocol}//hrmbackendapi.${window.location.hostname.replace('hrm.', '')}`;
const API_BASE_URL = `${cleanPort}/api/facebook`;

const fbClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getFacebookConfigAPI = async (params = {}) => {
  const response = await fbClient.get('/', { params });
  return response.data;
};

export const createFacebookConfigAPI = async (data) => {
  const response = await fbClient.post('/', data);
  return response.data;
};

export const getFacebookConfigByIdAPI = async (id) => {
  const response = await fbClient.get(`/${id}`);
  return response.data;
};

export const updateFacebookConfigAPI = async (data) => {
  const response = await fbClient.put('/', data);
  return response.data;
};

export const deleteFacebookConfigAPI = async (id) => {
  const response = await fbClient.delete(`/${id}`);
  return response.data;
};

export const getFacebookLeadsAPI = async (params = {}) => {
  const response = await fbClient.get('/lead', { params });
  return response.data;
};

export const syncFacebookLeadAPI = async (data) => {
  const response = await fbClient.post('/sync-data', data);
  return response.data;
};

export const getUniqueAdsAPI = async () => {
  const response = await fbClient.get('/unique-ads');
  return response.data;
};

export const passLeadsToCrmAPI = async (data) => {
  const response = await fbClient.post('/pass-crm', data);
  return response.data;
};
